import {Component} from 'react';
import {Author, Content, Header, Modal} from '../../components';
import styles from './App.module.scss';
import cn from "classnames";

export class App extends Component {
    state = {
        author: true,
        hideAuthor: false,
        start: false
    }

    toggleState = (name) => {
        this.setState({
            [name]: !this.state[`${name}`]
        })
    };

    onClickAuthor = () => {
        this.toggleState('hideAuthor');
        setTimeout(() => {
            this.toggleState('author');
            setTimeout(() => {
                this.toggleState('start');
            }, 600);
        }, 600);
    }

    render() {
        const {author, toggleState,  hideAuthor, start} = this.state;

        return (
            <>
                <Header/>

                {author ? <AuthorBlock hide={hideAuthor ? 'hide': ''} handler={this.onClickAuthor} onClose={this.onClickAuthor}/> : null}
                <div className={cn(styles.canvas, 'finished')}>
                    <Content toggleState={toggleState} start={start} />
                </div>
            </>
        );
    }
}

const AuthorBlock = ({handler, onClose, hide}) => {
    const content = <div className={styles.modal}><Author handler={handler}/></div>;
    return <Modal show={hide} type={'big'} onClose={onClose}>{content}</Modal>;
}
